import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/seekpass',
    authDomain: 'login.staging.seek.com',
    brand: Brand.SEEKPASS,
    clientDomain: 'www.seekpass-staging.com',
    clientId: '4Gq8EKajMqzuIxy0mvoY4DtWAslIZBRy',
    contactUs: {
        en: 'https://help.seekpass.co/hc/en-us/requests/new',
    },
    environment: 'dev',
    product: Product.SEEKPASS,
    realm: 'Username-Password-Authentication',
    redirectPath: '/auth-redirect',
};
//# sourceMappingURL=staging_seekpass_co.js.map